import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { YMaps } from '@pbe/react-yandex-maps';

import OrderListPage from './OrderListPage';
import { OrderPage } from './orderPage';
import { API_GEOCODE_LOCATION_URI, YANDEX_MAPS_API_KEY } from '../../../constants';

export default function CategoriesPage() {
  return (
    <YMaps query={{ lang: 'ru_RU', apikey: YANDEX_MAPS_API_KEY }}>
      <Routes>
        <Route path='list/:type' element={<OrderListPage />} />
        <Route path='create' element={<OrderPage />} />
        <Route path=':id/:mode' element={<OrderPage />} />
      </Routes>
    </YMaps>
  );
}
